import { Injectable } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Title } from "@angular/platform-browser";
import { Gtag } from "angular-gtag";

@Injectable({
  providedIn: "root",
})
export class SendEventGoogleService {
  default_title = "Tailor Made";

  constructor(
    private router: Router,
    private title: Title,
    private gtag: Gtag
  ) {}

  // collect that title data properties from all child routes
  // there might be a better way but this worked for me
  getTitle(state, parent) {
    var data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data.title) {
      data.push(parent.snapshot.data.title);
    }

    if (state && parent) {
      data.push(...this.getTitle(state, state.firstChild(parent)));
    }
    return data;
  }

  trackPageView() {
    let title = this.getTitle(
      this.router.routerState,
      this.router.routerState.root
    ).join("-");

    this.gtag.pageview({
      page_title: title,
      page_path: this.router.url,
    });
    this.title.setTitle("Tailor Made Tereos - "+title);
  }
}
